<template>
    <div
        id="main-container"
        class="is-justify-content-center has-background-greyBG"
    >
        <main class="box-center-vertical is-justify-content-center">
            <div class="columns is-centered mt-6">
                <div class="column is-12">
                    <div class="columns box is-block is-radiusless">
                        <div class="column is-12 is-inline-flex">
                            <h6
                                class="is-subtitle is-primary has-text-weight-medium is-pull-left"
                            >
                                {{ $t("call-register.title") }}
                            </h6>
                            <img
                                class="iconRegistro ml-4"
                                src="@/assets/icons/callRegister.svg"
                                width="30"
                                height="25"
                            />
                        </div>
                        <div class="column is-12 is-inline-flex">
                            <DataViewer
                                :getPagedData="getItems"
                                :notifyError="notifyError"
                                :fields="roomFields"
                                :onRowSelect="openRoom"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import moment from "moment";
import DataViewer from "@/components/datatable/DataViewer";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "rooms-list",
    components: {
        DataViewer,
    },
    data() {
        return {
            roomFields: [
                {
                    ref: "startDate",
                    displayText: "Fecha",
                    cellClass: "is-vcentered",
                    render: (value) => {
                        return moment(value).locale("es").format("DD/MM/YYYY");
                    },
                },
                {
                    ref: "startDate",
                    displayText: "Hora",
                    cellClass: "is-vcentered",
                    render: (value) => {
                        return moment(value).locale("es").format("hh:mm");
                    },
                },
                {
                    ref: "duration",
                    displayText: "Duración",
                    cellClass: "is-vcentered",
                },
                {
                    ref: "title",
                    displayText: "Motivo",
                    cellClass: "is-vcentered",
                },
                {
                    ref: "numberParticipant",
                    displayText: "Número de Participantes",
                    cellClass: "is-vcentered",
                },
            ],
        };
    },
    methods: {
        async getItems(payload) {
            try {
                var response = await RepositoryFactory.conference.getPagedConferences(
                    payload
                );
                window.console.log(response.data);
                return response;
            } catch (error) {
                window.console.log(error);
                window.console.log(error.message);
            }
        },
        notifyError(error) {
            window.console.log(error);
            window.console.log(error.message);
        },
        openRoom(room) {
            this.$router.push({
                name: "room-info",
                params: { roomId: room.id },
            });
        },
    },
};
</script>
